"use client";

import { useLocale } from "next-intl";
import { Link, usePathname } from "@/i18n/navigation";
import { Languages } from "@/lib/shared/constants";
import { useDisclosure } from "@/lib/shared/hooks";
import {
  Button,
  cn,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuTrigger,
  HStack,
  Text,
} from "@/ui";

interface LanguageSelectorProps {
  className?: string;
}

/**
 * LanguageSelector component - Language selection dropdown
 */
export const LanguageSelector = ({ className }: LanguageSelectorProps) => {
  const { isOpen, toggle } = useDisclosure();
  const pathName = usePathname();
  const locale = useLocale();

  return (
    <DropdownMenu
      open={isOpen}
      onOpenChange={(open: boolean) => toggle(open)}
    >
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          className={cn("px-1 sm:px-2", className)}
          data-testid="language-selector-trigger"
        >
          <HStack className="items-center">
            <Text className="uppercase">{locale}</Text>
          </HStack>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent className="z-50 w-40">
        <DropdownMenuGroup>
          {Object.entries(Languages).map(([key, value]) => {
            return (
              <Link
                key={key}
                href={pathName}
                locale={value}
                data-testid={`locale-option-${value}`}
              >
                <DropdownMenuItem className={locale === value ? "bg-base-300" : ""}>
                  {key}
                </DropdownMenuItem>
              </Link>
            );
          })}
        </DropdownMenuGroup>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
